import React from 'react';
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Typography,
} from '@mui/material';
import { withStyles } from '@mui/styles';

const styles = (theme) => ({
  root: {
    background: 'white',
    padding: '30px',
    direction: 'ltr',
    '& *': {
      fontFamily: 'Vazir',
    },
  },
  table: {
    backgroundColor: 'white',
  },
  cell: {
    fontSize: 13,
  },
  title: {
    textAlign: 'center',
    fontSize: 14,
    fontWeight: 'bold',
    marginRight: 'auto',
    marginLeft: 'auto',
    marginBottom: 15,
  },
});

class ComponentToPrint extends React.PureComponent {
  render() {
    const { classes, titles = [], data = [], title } = this.props;

    return (
      <Grid container className={classes.root}>
        {title ? <Typography className={classes.title}>{title}</Typography> : null}
        <TableContainer component={Paper} className={classes.table}>
          <Table>
            <TableHead>
              {titles.length > 0 ? (
                <TableRow>
                  {titles.map((v) => (
                    <TableCell className={classes.cell} align="center">
                      {v}
                    </TableCell>
                  ))}
                </TableRow>
              ) : null}
              {data.length > 0 ? (
                <>
                  {data.map((r, i) => (
                    <TableRow key={i}>
                      {r.map((v, k) => (
                        <TableCell className={classes.cell} key={k} align="center" dir="ltr">
                          {v}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </>
              ) : null}
            </TableHead>
          </Table>
        </TableContainer>
      </Grid>
    );
  }
}

export default withStyles(styles)(ComponentToPrint);
